// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fq-a";
export var fulfillmentFormRail = "_fq-9";
export var headerTitleRow = "_fq-c";
export var orderDetailsWrapper = "_fq-7";
export var orderLinkTrigger = "_fq-2";
export var paymentInformationGrid = "_fq-h";
export var paymentSummaryColumn = "_fq-i";
export var shipmentContainer = "_fq-b";
export var shipmentDetailsMainPane = "_fq-8";
export var shipmentNavigationCard = "_fq-5";
export var shipmentNavigationRail = "_fq-3";
export var shipmentNavigationRailHeader = "_fq-4";
export var shipmentSummaryFact = "_fq-e";
export var shipmentSummaryGrid = "_fq-d";
export var shipmentSummaryMetadataRow = "_fq-f";
export var shipmentSummaryTags = "_fq-g";
export var shipmentWorkspace = "_fq-0";
export var shipmentWorkspaceContent = "_fq-6";
export var shipmentWorkspaceHeader = "_fq-1";